/** 12 Houses (Bhavas), English labels + Hindi copy for Jyotish */

export { BHAVA_INTRO, BHAVA_INTRO_HI, BHAVA_MEMORY_TRICK } from './jyotishaBhavaPageCopy';

export const BHAVA_HOUSES = [
  {
    num: 1,
    titleEn: '1st House, Tanu Lord',
    titleHi: 'तनु भाव / लग्न',
    rulerEn: 'Mars',
    rulerHi: 'मंगल',
    karakEn: 'Sun',
    karakHi: 'सूर्य',
    significanceHi: 'स्व, व्यक्तित्व, शरीर, आत्मविश्वास',
    significanceEn: 'Self, body, personality',
    bodyHi: 'सिर',
    bodyEn: 'Head',
    directionHi: 'पूर्व',
    directionEn: 'East',
    colorHi: 'लाल',
    colorEn: 'Red',
    varnaHi: 'क्षत्रीय',
    varnaEn: 'Kshatriya',
    attributesHi: 'पहचान, स्वास्थ्य, आत्मविश्वास',
    attributesEn: 'Identity, health, confidence',
    focusListHi: [
      'रूप',
      'रंग',
      'स्वास्थ्य',
      'शारीरिक बनावट',
      'क्रूर-शान्त आदि',
      'सुख-दुःख स्वभाव',
      'मस्तिष्क - सिर',
      'आत्मा',
      'साहस',
      'आयुप्रमाण',
      'मस्तक बनावट',
      'व्यक्तिगत विचार',
      'प्रारम्भिक जीवन',
      'पूर्व दिशा',
    ],
  },
  {
    num: 2,
    titleEn: '2nd House, Dhana Lord',
    titleHi: 'धन भाव',
    rulerEn: 'Venus',
    rulerHi: 'शुक्र',
    karakEn: 'Jupiter',
    karakHi: 'गुरु',
    significanceHi: 'धन, परिवार, वाणी, भोजन',
    significanceEn: 'Wealth, family, speech',
    bodyHi: 'मुख, गला',
    bodyEn: 'Face, throat',
    directionHi: 'ईशान (उत्तर-पूर्व)',
    directionEn: 'North-East',
    colorHi: 'श्वेत',
    colorEn: 'White',
    varnaHi: 'वैश्य',
    varnaEn: 'Vaishya',
    attributesHi: 'धन, मूल्य, वाणी',
    attributesEn: 'Money, food, values',
    focusListHi: [
      'धन संग्रह',
      'पारिवारिक सुख-दुख',
      'कुटुम्ब',
      'संचित धन',
      'खाद्य पदार्थ',
      'दाहिनी आंख',
      'नाक',
      'कण्ठ, वाणी',
      'कण्ठ स्वर',
      'वक्तृत्व शक्ति',
      'गायन / संगीत',
      'लेखन कला',
    ],
  },
  {
    num: 3,
    titleEn: '3rd House, Sahaja Lord',
    titleHi: 'सहज भाव',
    rulerEn: 'Mercury',
    rulerHi: 'बुध',
    karakEn: 'Mars',
    karakHi: 'मंगल',
    significanceHi: 'साहस, भाई-बहन, लघु यात्रा',
    significanceEn: 'Courage, siblings',
    bodyHi: 'भुजा, कंधे',
    bodyEn: 'Arms, shoulders',
    directionHi: 'ईशान (उत्तर-पूर्व)',
    directionEn: 'North-East',
    colorHi: 'हरा',
    colorEn: 'Green',
    varnaHi: 'शूद्र',
    varnaEn: 'Shudra',
    attributesHi: 'संवाद, परिश्रम, कौशल',
    attributesEn: 'Communication, effort, skills',
    focusListHi: [
      'छोटे भाई-बहिन',
      'साहस',
      'मेहनत / उद्यम',
      'निकट यात्रा',
      'नौकरी से सुख-दुख',
      'पड़ोसी',
      'लेखन',
      'पत्राचार',
      'दाहिना कान',
      'गले का निचला भाग',
      'खांसी / दमा / फेफड़े',
      'चाचा - चाची',
      'कम्प्यूटर ज्ञान',
    ],
  },
  {
    num: 4,
    titleEn: '4th House, Bandhu Lord',
    titleHi: 'बन्धु भाव',
    rulerEn: 'Moon',
    rulerHi: 'चंद्रमा',
    karakEn: 'Moon, Mercury',
    karakHi: 'चंद्र, बुध',
    significanceHi: 'गृह, माता, सुख, वाहन',
    significanceEn: 'Home, mother, comfort',
    bodyHi: 'वक्ष (छाती)',
    bodyEn: 'Chest',
    directionHi: 'उत्तर',
    directionEn: 'North',
    colorHi: 'श्वेत / चाँदी जैसा',
    colorEn: 'White / Silver',
    varnaHi: 'ब्राह्मण',
    varnaEn: 'Brahmin',
    attributesHi: 'भावना, भूमि-भवन, शांति',
    attributesEn: 'Emotions, property, peace',
    focusListHi: [
      'माता',
      'सम्पत्ति',
      'सुख-दुख',
      'भूमि',
      'चौपाया (पशु)',
      'वस्त्राभूषण',
      'वाहन',
      'मानसिक संतोष',
      'कृषि',
      'घर का सुख',
      'ठाठ-बाट',
      'संवेदनशीलता',
      'छाती',
      'हृदय रोग',
      'जीवन का अंतिम समय',
    ],
  },
  {
    num: 5,
    titleEn: '5th House, Putra Lord',
    titleHi: 'पुत्र भाव',
    rulerEn: 'Sun',
    rulerHi: 'सूर्य',
    karakEn: 'Jupiter',
    karakHi: 'गुरु',
    significanceHi: 'संतान, बुद्धि, शिक्षा, रचनात्मकता',
    significanceEn: 'Children, intelligence',
    bodyHi: 'हृदय, उदर का ऊपरी भाग',
    bodyEn: 'Heart, stomach',
    directionHi: 'वायव्य (उत्तर-पश्चिम)',
    directionEn: 'North-West',
    colorHi: 'सुनहरा',
    colorEn: 'Golden',
    varnaHi: 'क्षत्रीय',
    varnaEn: 'Kshatriya',
    attributesHi: 'सृजन, विद्या, प्रेम-रोमांस',
    attributesEn: 'Creativity, education, romance',
    focusListHi: [
      'विद्या',
      'बुद्धि',
      'स्मरण शक्ति',
      'विचार शक्ति',
      'लेखन कला',
      'संतान',
      'गर्भ धारण / गर्भाशय',
      'प्रबन्धन शक्ति',
      'नीति',
      'मंत्र / शास्त्र ज्ञान',
      'लॉटरी आदि से लाभ',
      'भविष्य ज्ञान',
      'प्रेम संबंध',
      'दांत',
      'उदर / आमाशय',
    ],
  },
  {
    num: 6,
    titleEn: '6th House, Ari Lord',
    titleHi: 'अरि भाव',
    rulerEn: 'Mercury',
    rulerHi: 'बुध',
    karakEn: 'Mars, Saturn',
    karakHi: 'मंगल, शनि',
    significanceHi: 'शत्रु, रोग, ऋण, सेवा',
    significanceEn: 'Enemies, disease, debts',
    bodyHi: 'अन्त्र',
    bodyEn: 'Intestines',
    directionHi: 'वायव्य (उत्तर-पश्चिम)',
    directionEn: 'North-West',
    colorHi: 'गाढ़ा हरा',
    colorEn: 'Dark Green',
    varnaHi: 'शूद्र',
    varnaEn: 'Shudra',
    attributesHi: 'प्रतिस्पर्धा, सेवा, स्वास्थ्य',
    attributesEn: 'Competition, service, health',
    focusListHi: [
      'शत्रु',
      'रोग',
      'दुर्घटना',
      'चोटादि घाव',
      'ऋण',
      'मामा - मौसी',
      'सौतेली माता',
      'गुप्त शत्रु',
      'गुप्त दुःख',
      'झगड़ा',
      'चोरी',
      'अपमान',
      'धोखा',
      'नाभि / पेट के रोग',
      'निचला जबड़ा / दांत',
    ],
  },
  {
    num: 7,
    titleEn: '7th House, Yuvati Lord',
    titleHi: 'युवति भाव',
    rulerEn: 'Venus',
    rulerHi: 'शुक्र',
    karakEn: 'Venus',
    karakHi: 'शुक्र',
    significanceHi: 'विवाह, जीवनसाथी, साझेदारी',
    significanceEn: 'Marriage, partnerships',
    bodyHi: 'निचला उदर',
    bodyEn: 'Lower abdomen',
    directionHi: 'पश्चिम',
    directionEn: 'West',
    colorHi: 'हल्का नीला',
    colorEn: 'Light Blue',
    varnaHi: 'वैश्य',
    varnaEn: 'Vaishya',
    attributesHi: 'रिश्ते, व्यापारिक गठबंधन',
    attributesEn: 'Relationships, business',
    focusListHi: [
      'पति / पत्नी',
      'विवाह',
      'काम-वासना',
      'साझेदारी',
      'वाद-विवाद',
      'विदेश यात्रा',
      'प्रवास',
      'लघु-यात्राएं',
      'प्रत्यक्ष शत्रु',
      'स्थानांतरण',
      'काम-विकार',
      'जनप्रिय',
      'दैहिक लालसिकता',
      'मारक भाव',
    ],
  },
  {
    num: 8,
    titleEn: '8th House, Randhra Lord',
    titleHi: 'रन्ध्र भाव',
    rulerEn: 'Mars',
    rulerHi: 'मंगल',
    karakEn: 'Saturn',
    karakHi: 'शनि',
    significanceHi: 'आयु, परिवर्तन, अचानक घटनाएँ',
    significanceEn: 'Longevity, transformation',
    bodyHi: 'गुप्त अंग',
    bodyEn: 'Private parts',
    directionHi: 'नैऋत्य (दक्षिण-पश्चिम)',
    directionEn: 'South-West',
    colorHi: 'काला / गाढ़ा लाल',
    colorEn: 'Black / Dark Red',
    varnaHi: 'मिश्र',
    varnaEn: 'Mixed',
    attributesHi: 'रहस्य, गूढ़ विद्या, वंशानुगत',
    attributesEn: 'Secrets, sudden events, occult',
    focusListHi: [
      'मृत्यु',
      'दुःख',
      'आयु',
      'मृत्यु का कारण',
      'मानसिक चिन्ता',
      'व्याधि / आघात',
      'कलह',
      'गुप्त धन',
      'उत्तराधिकार',
      'दुर्घटना',
      'वसीयत द्वारा धन-लाभ',
      'मृत्यु के बाद गति',
      'ससुराल की स्थिति',
      'पाप',
      'व्यसन',
      'अंडकोष + रोग',
      'गुदा',
    ],
  },
  {
    num: 9,
    titleEn: '9th House, Dharma Lord',
    titleHi: 'धर्म भाव',
    rulerEn: 'Jupiter',
    rulerHi: 'गुरु (बृहस्पति)',
    karakEn: 'Sun, Jupiter',
    karakHi: 'सूर्य, गुरु',
    significanceHi: 'भाग्य, धर्म, गुरु, तीर्थ',
    significanceEn: 'Luck, religion, guru',
    bodyHi: 'जंघा',
    bodyEn: 'Thighs',
    directionHi: 'नैऋत्य (दक्षिण-पश्चिम)',
    directionEn: 'South-West',
    colorHi: 'पीला',
    colorEn: 'Yellow',
    varnaHi: 'ब्राह्मण',
    varnaEn: 'Brahmin',
    attributesHi: 'उच्च ज्ञान, पुण्य, दीर्घ यात्रा',
    attributesEn: 'Fortune, higher knowledge',
    focusListHi: [
      'धर्म',
      'भाग्य',
      'प्रारब्ध',
      'धार्मिक प्रवृत्ति',
      'दान - पुण्य',
      'तीर्थ यात्रा',
      'गुरु दीक्षा',
      'स्वप्न विद्या',
      'ईश्वरीय ज्ञान',
      'आध्यात्मिक विद्या',
      'दार्शनिकता',
      'पिता',
      'पोता - पोती',
      'भाभी - जीजा',
      'साला - साली',
      'दूर',
    ],
  },
  {
    num: 10,
    titleEn: '10th House, Karma Lord',
    titleHi: 'कर्म भाव',
    rulerEn: 'Saturn',
    rulerHi: 'शनि',
    karakEn: 'Sun, Mercury, Jupiter, Saturn',
    karakHi: 'सूर्य, बुध, गुरु, शनि',
    significanceHi: 'करियर, मान-सम्मान, पिता से संबंध',
    significanceEn: 'Career, status',
    bodyHi: 'घुटने',
    bodyEn: 'Knees',
    directionHi: 'दक्षिण',
    directionEn: 'South',
    colorHi: 'गाढ़ा नीला',
    colorEn: 'Dark Blue',
    varnaHi: 'शूद्र',
    varnaEn: 'Shudra',
    attributesHi: 'व्यवसाय, कीर्ति, सार्वजनिक प्रतिष्ठा',
    attributesEn: 'Profession, reputation',
    focusListHi: [
      'कर्म',
      'व्यवसाय',
      'नौकरी',
      'पिता से सुख / संबंध',
      'पद प्रतिष्ठा',
      'अधिकार प्राप्ति',
      'नेतृत्व',
      'सरकारी लाभ',
      'उच्च शिक्षा में सफलता',
      'अच्छे-बुरे कर्म',
      'सार्वजनिक जीवन',
      'स्वाभिमान',
      'राजनैतिक प्रभाव',
      'घुटने',
    ],
  },
  {
    num: 11,
    titleEn: '11th House, Labha Lord',
    titleHi: 'लाभ भाव',
    rulerEn: 'Saturn',
    rulerHi: 'शनि',
    karakEn: 'Jupiter',
    karakHi: 'गुरु',
    significanceHi: 'लाभ, आय, मित्र-नेटवर्क',
    significanceEn: 'Gains, income',
    bodyHi: 'पिंडलियाँ',
    bodyEn: 'Calves',
    directionHi: 'आग्नेय (दक्षिण-पूर्व)',
    directionEn: 'South-East',
    colorHi: 'नीला',
    colorEn: 'Blue',
    varnaHi: 'शूद्र',
    varnaEn: 'Shudra',
    attributesHi: 'नफ़ा, इच्छा पूर्ति, बड़ा सर्किल',
    attributesEn: 'Profits, social network',
    focusListHi: [
      'लाभ',
      'आय',
      'बड़ा भाई / बहिन',
      'दायां कान',
      'पैतृक वस्तु',
      'द्वितीय पत्नी',
      'जीवन में सफलता',
      'मित्र सुख',
      'माता का सुख',
      'भतीजा',
      'पुत्र - बंधु',
      'जंघाता',
      'पिंडलियां',
    ],
  },
  {
    num: 12,
    titleEn: '12th House, Vyaya Lord',
    titleHi: 'व्यय भाव',
    rulerEn: 'Jupiter',
    rulerHi: 'गुरु (बृहस्पति)',
    karakEn: 'Saturn',
    karakHi: 'शनि',
    significanceHi: 'व्यय, विदेश, मोक्ष, नींद',
    significanceEn: 'Loss, liberation',
    bodyHi: 'पैर',
    bodyEn: 'Feet',
    directionHi: 'आग्नेय (दक्षिण-पूर्व)',
    directionEn: 'South-East',
    colorHi: 'समुद्री हरा',
    colorEn: 'Sea Green',
    varnaHi: 'ब्राह्मण',
    varnaEn: 'Brahmin',
    attributesHi: 'आध्यात्मिकता, खर्च, एकांत',
    attributesEn: 'Spirituality, expenses, foreign',
    focusListHi: [
      'खर्च',
      'हानि',
      'दान',
      'दण्ड',
      'व्यसन',
      'रोग',
      'बन्धन भय',
      'कारावास',
      'मोक्ष',
      'त्याग',
      'दूर यात्रा',
      'बायां नेत्र',
      'गुप्त विद्या',
      'परदेश गमन',
      'शयन सुख',
      'मृत्यु के बाद गति',
      'पांव',
    ],
  },
];

/** Map karak labels in BHAVA_HOUSES to English graha keys for GrahaHiEn. */
const KARAK_TOKEN_TO_EN = {
  sun: 'Sun',
  surya: 'Sun',
  moon: 'Moon',
  chandra: 'Moon',
  mars: 'Mars',
  mangal: 'Mars',
  mercury: 'Mercury',
  budh: 'Mercury',
  jupiter: 'Jupiter',
  guru: 'Jupiter',
  venus: 'Venus',
  shukra: 'Venus',
  saturn: 'Saturn',
  shani: 'Saturn',
  ketu: 'Ketu',
  rahu: 'Rahu',
};

/**
 * @param {number} house 1-12
 */
export function getBhavaForHouse(house) {
  return BHAVA_HOUSES.find((b) => b.num === house) ?? null;
}

/**
 * @param {string} karakEn e.g. "Sun", "Mars, Saturn", "Saturn / Ketu"
 * @returns {string[]} English graha names
 */
export function parseBhavaKarakPlanets(karakEn) {
  if (!karakEn?.trim()) return [];
  return karakEn
    .split(/[,/]/)
    .map((part) => {
      const token = part.trim().toLowerCase().replace(/\s+/g, '');
      if (KARAK_TOKEN_TO_EN[token]) return KARAK_TOKEN_TO_EN[token];
      const titled = part.trim().replace(/\b\w/g, (c) => c.toUpperCase());
      return KARAK_TOKEN_TO_EN[titled.toLowerCase()] ?? (titled.length ? titled : null);
    })
    .filter(Boolean);
}
